import { render, staticRenderFns } from "./ListTips.vue?vue&type=template&id=25df6704&scoped=true"
import script from "./ListTips.vue?vue&type=script&lang=js"
export * from "./ListTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df6704",
  null
  
)

export default component.exports